module.exports = __webpack_public_path__ + "img/defaultImg.016136f9.png";